<template>
  <v-layout
    :class="isCurrentEdition ? 'white' : 'deprecated deprecated_background'"
    align-space-between
    justify-start
    column
    fill-height
  >
    <v-flex
      shrink
      class="sz_background_light"
      py-3
    >
      <v-flex
        md10
        offset-md1
        sm12
        offset-sm0
      >
        <v-layout
          fill-height
          align-center
        >
          <v-flex shrink>
            <AppLogo width="60" />
          </v-flex>
          <v-flex ml-5>
            <h1 class="display-4">
              {{ title }}
            </h1>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-flex>
    <v-flex>
      <router-view />
    </v-flex>
  </v-layout>
</template>

<script>
import AppLogo from '@/components/widgets/AppLogo';

export default {
    name: 'DescriptionPage',
    components: {
        AppLogo
    },
    computed: {
        title () {
            if (this.$route.name === 'family-description') {
                return this.$t('description.volunteer_title');
            } else {
                return this.$t('preview.title');
            }
        },
        isCurrentEdition () {
            return this.$store.getters['family/isCurrentEdition'];
        }
    }
};
</script>

<style scoped></style>
